import Typography from '~/shared/components/Typography';

import UserAvatar from './UserAvatar';
import { LogoutButton } from './LogoutButton';
import { AdminButton } from './AdminButton';

interface UserProfileProps {
  userName: string;
  email: string;
  onLogoutClick: () => void;
}

export default function UserProfile({ userName, email, onLogoutClick }: UserProfileProps) {
  return (
    <div className="flex flex-col gap-[17px] border-b border-gray-200 pt-3 pb-4">
      <div className="flex items-center gap-[8px]">
        <UserAvatar username={userName || ''} size="xl-resp" />
        <div className="flex flex-col">
          <Typography
            variant="H4"
            fontWeight={600}
            color="text-primary-900 font-family-outfit capitalize"
          >
            {userName || ''}
          </Typography>
          <Typography variant="p2" color="text-gray-800">
            {email || ''}
          </Typography>
        </div>
      </div>
      <div className="flex items-center justify-between">
        <AdminButton />
        <LogoutButton onClick={onLogoutClick} />
      </div>
    </div>
  );
}
